module.exports = __webpack_public_path__ + "static/media/pantallainicio.9165ba7c.png";